import { getKvSyncApi } from '@/api/kvSync.js'
import kvSyncSubscriber from '@/mqtt/kvSync'
import { updateFeatureFlagsPlugin } from '@ahaslides-product/frontend-toolkit'
import * as Sentry from '@sentry/vue'

const _state = {
  subscribedKeys: new Set(),
}

const refetchSubscribedKeys = ({ state, dispatch }) => {
  Array.from(state.subscribedKeys).forEach((key) => {
    dispatch('fetchValueByKeyAction', {
      key,
    })
  })
}

const kvSyncApi = () => {
  return getKvSyncApi()
}

const actions = {
  listenConnectionEventAction: async ({ dispatch, state }) => {
    const client = kvSyncSubscriber.getClient()
    if (!client) return

    // MQTT-level reconnection events
    client.on('reconnect', () => {
      refetchSubscribedKeys({ state, dispatch })
    })

    // Browser-level network connectivity detection
    // This is more reliable for WiFi on/off scenarios
    const handleNetworkReconnection = () => {
      refetchSubscribedKeys({ state, dispatch })
    }

    // Listen for browser online event (WiFi reconnection)
    window.addEventListener('online', handleNetworkReconnection)
  },
  fetchValueByKeyAction: async ({ dispatch }, payload) => {
    if (!payload.key) return
    try {
      const resp = await kvSyncApi().getValueByKey(payload.key)
      const { value } = resp.body
      dispatch('updateKeyValueAction', {
        key: payload.key,
        value,
      })
    } catch (error) {
      if (error && error.status) {
        throw error
      }
    }
  },

  fetchValueByKeyWithoutUpdateAction: async (_, payload) => {
    try {
      const resp = await kvSyncApi().getValueByKey(payload.key)
      const { value } = resp.body
      return value
    } catch (error) {
      if (error && error.status) {
        Sentry.captureException(error)
      }
      return null
    }
  },

  createKeyValueAction: async (_, payload) => {
    await kvSyncApi().createKeyValue(payload)
  },

  subscribeKeyAction: async ({ dispatch, commit }, payload) => {
    if (!payload.isNotFetch) {
      dispatch('fetchValueByKeyAction', payload)
    }
    kvSyncSubscriber.subscribeKey(payload.key, (topic, message, packet) => {
      dispatch('updateKeyValueAction', {
        key: topic,
        value: message,
        packet,
      })
      if (payload.callback) {
        payload.callback(topic, message, packet)
      }
    }, payload.options)
    commit('addSubscribedKey', payload.key)
  },

  updateKeyValueAction: () => { }, // only declare the action, plugins will listen to this to update state accordingly

  unsubscribeKeyAction: async ({ commit }, payload) => {
    kvSyncSubscriber.unsubscribeKey(payload)
    commit('removeSubscribedKey', payload)
  },
}

const mutations = {
  addSubscribedKey(state, key) {
    state.subscribedKeys.add(key)
  },
  removeSubscribedKey(state, key) {
    state.subscribedKeys.delete(key)
  },
}

const plugins = [
  updateFeatureFlagsPlugin,
]

export default {
  namespaced: true,
  state: _state,
  actions,
  mutations,
  plugins,
}
